module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-18.91a04dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-18.jpg
// module id = 03+k
// module chunks = 52